import { Container, Link, Text } from "@simplybusiness/mobius";

export const GenericError = () => (
  <Container size="sm" className="error-boundary__container">
    <div className="error-boundary__message">
      <Text elementType="h1">Oops!</Text>
      <Text>
        Something went wrong - please{" "}
        <Link href="javascript:history.go(-1)">go back</Link> or try again,
        <br />
        or call us on 0333 014 6683 if in the UK or (844) 654-7272 if in the US.
      </Text>
    </div>
  </Container>
);
